import TableImage from './table.png';

export const emailModalImage = {
  table: TableImage
};
